import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
//import { DA_SERVICE_TOKEN } from '@delon/auth';
import {  SettingsService, User } from '@delon/theme';//I18nPipe,
import { AuthService } from '@share';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@Component({
  selector: 'header-user',
  template: `
    <div class="alain-default__nav-item d-flex align-items-center px-sm" nz-dropdown nzPlacement="bottomRight" [nzDropdownMenu]="userMenu">
      <nz-avatar [nzSrc]="user?.avatar" nzIcon="user" nzSize="small" class="mr-sm" />
      {{ user?.name }}
    </div>
    <nz-dropdown-menu #userMenu="nzDropdownMenu">
    <!-- routerLink="/pro/account/center" -->
      <div nz-menu class="width-sm">
        <!-- <div nz-menu-item >
          <i nz-icon nzType="user" class="mr-sm"></i>
          {{ 'Profile'}}
        </div> -->
        <li nz-menu-divider></li>
        <div nz-menu-item (click)="logout()">
          <i nz-icon nzType="logout" class="mr-sm"></i>
          {{ 'Logout'}}
        </div>
      </div>
    </nz-dropdown-menu>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    //RouterLink,
    NzDropDownModule,
    NzMenuModule,
    NzIconModule,
    //I18nPipe,
    NzAvatarModule],
})
export class HeaderUserComponent implements OnInit{
  ngOnInit(): void {
    this.authService.userState$.subscribe(x=>this.user=x);
  }
  public user:User|null=null;
  private readonly settings = inject(SettingsService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  // private readonly tokenService = inject(DA_SERVICE_TOKEN);
  getuser(): User {
    return this.authService.userState$.subscribe(x=>this.user=x);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }
}
